import pluralize from "pluralize";
import bytes from "bytes-iec";

export const pluralizeDeleteAssetsMessage = (count: number) =>
  `Are you sure you want to remove ${pluralize("asset", count, true)} from the playlist?`;

export const formatBytes = (bytesCount: number): string | null => {
  return bytes.format(bytesCount, { mode: "compatibility", decimalPlaces: 1, unitSeparator: " " });
};

export const formatDuration = (seconds: number): string => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return h > 0
    ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
    : `${m}:${String(s).padStart(2, "0")}`;
};

export const formatSampleRate = (sampleRate: number): string => `${(sampleRate / 1000).toFixed(1)} kHz`;

export const formatChannels = (channels: number): string =>
  channels === 1 ? "Mono" : channels === 2 ? "Stereo" : `${channels}ch`;
